import "./polyfills/browser";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@/assets/styles/main.scss";
import ProvideLayout from "./contexts/UseLayout";
import { GoonTransition } from "./services/notify.tsx";
import "react-datepicker/dist/react-datepicker.css";
import "animate.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-quill/dist/quill.snow.css";
import "./i18n";
import "react-confirm-alert/src/react-confirm-alert.css";
import Player from "lottie-react";
import loadingAnimation from "./assets/loading_screen.json";
import * as Sentry from "@sentry/react";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import RoutesMain from "./routes";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
  ],
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutos
    },
  },
});

function Splash() {
  return (
    <div className="w-screen h-screen bg-azul-400 flex justify-center items-center">
      <Player
        autoplay
        loop
        animationData={loadingAnimation}
        style={{ height: "100%", width: "100%" }}
      />
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={<Splash />}>
      <Sentry.ErrorBoundary fallback={<Splash />} showDialog={false}>
        <ProvideLayout>
          <RoutesMain />
        </ProvideLayout>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          pauseOnHover
          draggable
          limit={5}
          transition={GoonTransition}
        />
      </Sentry.ErrorBoundary>
    </Suspense>
  </QueryClientProvider>,
);
